import React from "react";
import { createEmptyRunTarget } from "../factories";
import Button from "../../../../../../../components/elements/Button";
import InputField from "../../../../../../../components/elements/InputField";
import CustomSelect from "../../../../../../../components/elements/CustomSelect";
import { RUNNERS_BY_TYPE } from "../../../../../../../utils/constants";

export default function RunTargetsEditor({
                                             targets,
                                             editors,
                                             path,
                                             updateAtPath,
                                             referencedIds
                                         }) {

    const addTarget = (type) => {
        updateAtPath(path, [
            ...targets,
            createEmptyRunTarget({ resultType: type })
        ]);
    };

    const deleteTarget = (index) => {
        const targetId = targets[index].id;

        if (referencedIds.includes(targetId)) {
            alert("Cannot delete: Target is used by a Validation Check.");
            return;
        }

        if (targets.length <= 1) {
            alert("Step must have at least one run target.");
            return;
        }

        updateAtPath(
            path,
            targets.filter((_, i) => i !== index)
        );
    };

    const editts = ["", ...editors.map(ed => ed.id)];

    return (
        <div className='p-10 bg-green-300 rounded-md'>
            <div className='flex justify-between items-center mb-5'>
                <h3>Run Targets</h3>

                <div className="flex items-center gap-5">
                    <Button onClick={() => addTarget("program")}>Program</Button>
                    <Button onClick={() => addTarget("web")}>Web</Button>
                    <Button onClick={() => addTarget("sql")}>SQL</Button>
                </div>
            </div>

            <div style={{ display: "grid", gap: 10 }}>
                {targets.map((target, idx) => {

                    const runnerOptions =
                        RUNNERS_BY_TYPE[target.resultType] || [];

                    return (
                        <div
                            key={target.id || idx}
                            className={`flex items-center justify-center rounded-md bg-white border-gray-200`}
                        >
                            {/* Header Row */}
                            <div className="flex items-center gap-5 mx-5 mt-5 mb-8">
                                <InputField
                                    value={target.id}
                                    onChange={e =>
                                        updateAtPath(
                                            [...path, idx, "id"],
                                            e.target.value
                                        )
                                    }
                                    title="Target ID"
                                />

                                <CustomSelect
                                    options={["program", "sql", "web"]}
                                    value={target.resultType}
                                    onChange={e => {
                                        const newType = e.target.value;

                                        // Reset incompatible fields safely
                                        updateAtPath(
                                            [...path, idx],
                                            {
                                                ...target,
                                                resultType: newType,
                                                runner: "",
                                                editorId: undefined,
                                                editorIds: undefined,
                                                stdin: undefined
                                            }
                                        );
                                    }}
                                />

                                <div style={{ flex: 1 }} />

                                <button
                                    type="button"
                                    onClick={() => deleteTarget(idx)}
                                >
                                    ✕
                                </button>
                            </div>

                            {/* Web Targets */}
                            {target.resultType === "web" ? (
                                <div className="grid grid-cols-3 gap-5 m-10">
                                    {["html", "css", "js"].map(lang => (
                                        <label key={lang}>
                                            {lang.toUpperCase()} Editor:
                                            <CustomSelect
                                                options={editts}
                                                value={
                                                    target.editorIds?.[lang] || ""
                                                }
                                                onChange={e =>
                                                    updateAtPath(
                                                        [...path, idx, "editorIds", lang],
                                                        e.target.value || undefined
                                                    )
                                                }
                                            />
                                        </label>
                                    ))}
                                </div>
                            ) : (
                                <div className="m-10 flex flex-col gap-6">
                                    <div>
                                        <label>Primary Editor:</label>
                                        <CustomSelect
                                            options={editts}
                                            value={target.editorId || ""}
                                            onChange={e =>
                                                updateAtPath(
                                                    [...path, idx, "editorId"],
                                                    e.target.value || undefined
                                                )
                                            }
                                        />
                                    </div>

                                    {target.resultType === "program" && (
                                        <div>
                                            <label>STDIN (Program Input)</label>
                                            <textarea
                                                value={target.stdin || ""}
                                                rows={4}
                                                style={{
                                                    width: "100%",
                                                    border: "1px solid #ccc",
                                                    padding: 6
                                                }}
                                                placeholder={"Example:\n5\n10"}
                                                onChange={e =>
                                                    updateAtPath(
                                                        [...path, idx, "stdin"],
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Runner */}
                            <div className="m-10">
                                <CustomSelect
                                    label="Runner"
                                    options={runnerOptions}
                                    value={target.runner || ""}
                                    onChange={e =>
                                        updateAtPath(
                                            [...path, idx, "runner"],
                                            e.target.value
                                        )
                                    }
                                />
                            </div>

                        </div>
                    );
                })}
            </div>
        </div>
    );
}
